import { EmailEditorContentI } from "./index";

/**
 * Adjust the output of the email editor content to be fully compatible with
 * gmail formatting.
 */
export const processEmailEditorContent = ({
  plainText,
  htmlText,
}: EmailEditorContentI) => {
  return {
    plainText,
    htmlText: htmlText
      ? htmlText
          .replace(/<div><\/div>/g, "<div><br></div>")
          .replace(/<br class="ProseMirror-trailingBreak">/g, "")
      : "",
  };
};

/**
 * Normalise HTML on the way *into* the editor.
 *
 * A paragraph spacer on the wire is `<div><br></div>` - an empty block whose
 * content is a single line break. That is correct for an email client, but
 * ProseMirror renders a trailing hard break with an extra
 * `<br class="ProseMirror-trailingBreak">` so the break itself stays visible.
 * The spacer therefore displays as TWO blank lines while
 * processEmailEditorContent exports it back as one, so the draft the SDR sees
 * is more widely spaced than the email that actually goes out.
 *
 * Dropping the `<br>` on the way in leaves an empty block. ProseMirror supplies
 * its own trailing break for display (one blank line) and the export path turns
 * `<div></div>` back into `<div><br></div>` (one blank line in the inbox), so
 * both ends agree.
 */
export const normalizeEmailEditorContent = (htmlText?: string) => {
  if (!htmlText) {
    return "";
  }

  return htmlText.replace(/<div>\s*<br\s*\/?>\s*<\/div>/gi, "<div></div>");
};
